import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export default function ViewerGuard({ children, redirectTo = '/' }) {
  const { canEdit, loading } = useAuth()
  if (loading) return null
  if (!canEdit) return <Navigate to={redirectTo} replace />
  return children
}
